module.exports = __webpack_public_path__ + "static/img/jbfxbj_jcjg_icon.png";